import React from 'react';
import classNames from 'classnames';

import styles from './SquareBody.module.scss';

const { 'square-body': squareBodyClass } = styles;

const SquareBody = ({ children, customClass }) => {
  const squareBodyClasses = classNames(squareBodyClass, {
    [customClass]: !!customClass
  });

  return <div className={squareBodyClasses}>{children}</div>;
};

export default SquareBody;
